const tokenTypes = {
  KEYWORD: 'keyword',
  IDENTIFIER: 'identifier',
  OPERATOR: 'operator',
  CONSTANT: 'constant',
  DELIMITER: 'delimiter',
  INVALID: 'invalid'
};
const tokenSubTypes = {
  // keywords
  AS: 'as',
  // identifiers
  FUNCTION_NAME: 'functionName',
  BASIC_FIELD: 'basicField',
  ALIAS: 'alias',
  // constants
  BOOLEAN: 'boolean',
  STRING: 'string',
  NUMBER: 'number',
  NULL: 'null',
  // operators
  MATH: 'math',
  LOGICAL: 'logical',
  // delimiters
  COMMA: 'comma'
};
export { tokenTypes, tokenSubTypes };